import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export interface ActivePolicyVersion {
	_id: string;
	policyType: string;
	versionNumber: string;
	effectiveDate: string;
	isActive: boolean;
}

export const useActivePolicies = () => {
	return useQuery<ActivePolicyVersion[]>({
		queryKey: ['policies', 'active'],
		queryFn: async () => {
			const { data } = await api.get<ActivePolicyVersion[]>('/policy-version/findAll');
			return data;
		},
		staleTime: 1000 * 60 * 10,
		retry: false,
	});
};
